

// import React from 'react';
// import './LocationSection.css';

// export default function LocationSection() {
//   const mapSrc =
//     "https://maps.google.com/maps?q=gym+arena&output=embed&z=15";

//   return (
//     <section id="location" className="location-section">
//       <div className="container">

//         {/* 🔥 HEADER */}
//         <p className="section-label">Find Us</p>

//         <h2 className="section-title">
//           Our <span>Location</span>
//         </h2>

//         <div className="divider" />

//         {/* 🔥 MAIN CONTENT */}
//         <div className="location-content">

//           {/* 🔥 MAP */}
//           <div className="location-map">
//             <iframe
//               title="Gym Arenaa Location"
//               src={mapSrc}
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//             />
//           </div>

//           {/* 🔥 INFO BOX */}
//           <div className="location-info">

//             <h3 className="location-info__title">Gym Arenaa</h3>

//             {/* ADDRESS */}
//             <div className="location-detail">
//               <div className="location-detail__icon">📍 Address</div>
//               <div>
//                 <p className="location-detail__label"></p>
//                 <p className="location-detail__value">
//                   2nd Floor, NMS Titanium, near McDonalds, Sector 15,
//                   CBD Belapur, Navi Mumbai, Maharashtra, 400614
//                 </p>
//               </div>
//             </div>

//             {/* HOURS */}
//             <div className="location-detail">
//               <div className="location-detail__icon">🕐 Hours</div>
//               <div>
//                 <p className="location-detail__label"></p>
//                 <p className="location-detail__value">
//                   Mon - Fri: 5:30 AM to 10:00 PM
//                 </p>
//                 <p className="location-detail__value">
//                   Sat - Sun: 7:00 AM to 4:00 PM
//                 </p>
//               </div>
//             </div>

//             {/* CONTACT */}
//             <div className="location-detail">
//               <div className="location-detail__icon">📞 Contact</div>
//               <div>
//                 {/* <p className="location-detail__label">Contact</p> */}

//                 {/* 🔥 Clickable phone */}
//                 <a href="tel:+919022554999" className="location-detail__value link">
//                   +91 9022554999
//                 </a>
//               </div>
//             </div>

//             {/* 🔥 BUTTON */}
//             <div className="location-btn-wrap">
//               <a
//                 href="https://www.google.com/maps/place/Gym+Arenaa/@19.0088996,73.0357359,17z/data=!3m1!4b1!4m6!3m5!1s0x3be7c3aa1197de67:0x6f0c1d3b032ea8dc!8m2!3d19.0088996!4d73.0357359!16s%2Fg%2F11g6hw600m!18m1!1e1?entry=ttu"
//                 target="_blank"
//                 rel="noreferrer"
//                 className="location-directions-btn"
//               >
//                 Get Directions
//               </a>
//             </div>

//           </div>
//         </div>

//       </div>
//     </section>
//   );
// }



import React from 'react';
import './LocationSection.css';

export default function LocationSection() {
  const mapSrc =
   "https://maps.google.com/maps?q=2nd+Floor,+NMS+Titanium,+CBD+Belapur,+Navi+Mumbai&output=embed";
  return (
    <section id="location" className="location-section">
      <div className="container">

        {/* HEADER */}
        <p className="section-label">Find Us</p>

        <h2 className="section-title">
          Our <span>Location</span>
        </h2>

        <div className="divider" />

        {/* MAIN CONTENT */}
        <div className="location-content">

          {/* MAP */}
          <div className="location-map">
            <iframe
              title="Gym Arenaa Location"
              src={mapSrc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* INFO BOX */}
          <div className="location-info">

            <h3 className="location-info__title">Gym Arenaa</h3>

            {/* ADDRESS */}
            <div className="location-detail">
              <div className="location-detail__icon">📍 Address</div>
              <div>
                {/* <p className="location-detail__label">Address</p> */}
                <p className="location-detail__value">
                  2nd Floor, NMS Titanium, near McDonalds, Sector 15,
                  CBD Belapur, Navi Mumbai, Maharashtra, 400614
                </p>
              </div>
            </div>

            {/* HOURS */}
            <div className="location-detail">
              <div className="location-detail__icon">🕐 Hours</div>
              <div>
                {/* <p className="location-detail__label">Hours</p> */}
                <p className="location-detail__value">
                  Mon - Fri: 5:30 AM to 10:00 PM
                </p>
                <p className="location-detail__value">
                  Sat - Sun: 7:00 AM to 4:00 PM
                </p>
              </div>
            </div>

            {/* CONTACT */}
            <div className="location-detail">
              <div className="location-detail__icon">📞 Contact</div>
              <div>
                {/* <p className="location-detail__label">Contact</p> */}
                <a href="tel:+919022554999" className="location-detail__value link">
                  +91 9022554999
                </a>
              </div>
            </div>

            {/* 🔥 BUTTON */}
            <div className="location-btn-wrap">
              <a
                href="https://www.google.com/maps?q=2nd+Floor,+Gym+Arenaa,+NMS+Titanium,+Dausha+Ram+Mahatrey+Marg,+near+McDonalds,+Sector+15,+CBD+Belapur,+Navi+Mumbai,+Maharashtra+400614&ftid=0x3be7c3aa1197de67:0x6f0c1d3b032ea8dc&entry=gps&shh=CAE&lucs=,94297699,94275415,94284493,94231188,94280568,47071704,94218641,94282134,94286869&g_ep=CAISEjI2LjA2LjIuODY0NDM1MTkzMBgAINeCAypRLDk0Mjk3Njk5LDk0Mjc1NDE1LDk0Mjg0NDkzLDk0MjMxMTg4LDk0MjgwNTY4LDQ3MDcxNzA0LDk0MjE4NjQxLDk0MjgyMTM0LDk0Mjg2ODY5QgJJTg%3D%3D&skid=99a83d80-d26c-464e-969c-ee84f57c9e91&g_st=iw"
                target="_blank"
                rel="noreferrer"
                className="location-btn"
              >
                Get Directions
              </a>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}